import useMapEnum from "src/functions/mappers/use-map-enum";
import { EmploymentStatus_Enum } from "src/types/enums";

const employmentStatusOptions = useMapEnum(Object.values(EmploymentStatus_Enum))

export default employmentStatusOptions;
